module.exports = __webpack_public_path__ + "static/media/AddLogoDegraded.a24d579f.svg";